module.exports = __webpack_public_path__ + "media/index/abc-news-29f050bc.svg";